import client from './client';

export const myCoachApi = {
  summary: () => client.get('/users/me/coach-summary'),
};
